export { default as PbNav } from './component';
